// Shared style constants for components

// Base card styling with responsive padding and text size
export const CARD_BASE = "bg-surface-default dark:bg-surface-default rounded-lg shadow-md dark:shadow-none p-2 md:p-4 xl:p-6 text-xs md:text-sm xl:text-base";

// Common input and select styling
export const INPUT_BASE = "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-xs md:text-sm text-gray-900 dark:text-gray-100";

// Common select styling
export const SELECT_BASE = "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-xs md:text-sm text-gray-900 dark:text-gray-100 bg-surface-default dark:bg-surface-default";

// Label styling
export const LABEL_BASE = "block text-xs md:text-sm font-medium text-gray-700 dark:text-gray-300";

// Section heading styling
export const SECTION_HEADING = "text-base md:text-lg xl:text-xl font-semibold text-gray-900 dark:text-gray-100";

// Card spacing
export const CARD_SPACING = {
  section: "space-y-2 md:space-y-4",
  row: "space-y-1 md:space-y-2",
  grid: "gap-2 md:gap-4",
}; 